import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../store";
import type { InboxCategoryTags } from "./types";

export const inboxStructureSelector = (state: RootState) => state.inboxStructure.tree;

export const categoryTagsSelector = createSelector(
  [(state: RootState) => state.inboxStructure.tree],
  (tree) => (tree["categoryTags"] as InboxCategoryTags[]) ?? []
);

export const inboxStructureLoadingSelector = (state: RootState) => state.inboxStructure.loading;
